module.exports = "https://static.energy5.com/_next/static/images/step2Image-b0a6e6d26c7089c7e9d41455ba786684.jpg";